import { createContext, useContext, useState } from "react";

const TooltipContext = createContext();

export function TooltipProvider({ children }) {
  const [tooltipIndex, setTooltipIndex] = useState(null);

  return (
    <TooltipContext.Provider value={{ tooltipIndex, setTooltipIndex }}>
      {children}
    </TooltipContext.Provider>
  );
}

export function useTooltip() {
  return useContext(TooltipContext);
}
